<template>
  <div class="webshop-disabled">
    <div class="has-info" v-html="disabledMessage"></div>
    <p>
      <a :href="referrer" :title="referrer" @click.prevent="retry">
        <Spinner v-show="isLoading" />
        Probeer later opnieuw
      </a>
    </p>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getData } from "@/infrastructure/data-functions";
import { ref } from "vue";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const referrer = router.currentRoute.value.query.u || "/";
    // redirect to homepage when not disabled anymore
    if (!store.state.webshop.disabled) {
      router.replace(referrer);
      return;
    }
    const isLoading = ref(false);

    return {
      disabledMessage: store.state.webshop.disabledMessage,
      referrer,
      isLoading,
      retry: async () => {
        try {
          isLoading.value = true;
          const { disabled: isWebshopDisabled } = await getData(store.state.appId);
          if (!isWebshopDisabled) {
            router.replace(referrer);
          }
        } finally {
          isLoading.value = false;
        }
      },
    };
  },
};
</script>
